import React from 'react'
import FabricInquiriesDetails from './FabricInquiriesDetails'

const FabricInquiriesBody = () => {
    return (
        <div className="view-qualities folded router-view-container">
            <FabricInquiriesDetails />
        </div>
    )
}

export default FabricInquiriesBody